var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRecharge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0.02 29.95 29.95",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.9466 14.9889C29.9466 23.2585 23.2428 29.9622 14.9733 29.9622C6.70377 29.9622 0 23.2585 0 14.9889C0 6.7194 6.70377 0.015625 14.9733 0.015625C23.2428 0.015625 29.9466 6.7194 29.9466 14.9889ZM8.98127 20.9129H16.4024C16.5163 20.9129 16.5733 20.7708 16.5163 20.6714L10.5196 13.2422C10.4341 13.1428 10.2917 13.1854 10.2632 13.299L8.82457 20.7282C8.81032 20.8277 8.88155 20.9129 8.98127 20.9129ZM8.84177 9.69873H16.2629C16.3626 9.69873 16.4338 9.78396 16.4196 9.8834L14.9809 17.3126C14.9524 17.4263 14.81 17.4689 14.7245 17.3695L8.72781 9.92601C8.65658 9.84078 8.71356 9.69873 8.84177 9.69873ZM17.0174 9.81237C17.0316 9.75555 17.0886 9.69873 17.1598 9.69873H22.5013C22.5868 9.69873 22.6723 9.78396 22.658 9.86919L21.6609 14.6989C21.6467 14.7699 21.5897 14.8125 21.5185 14.8125H21.3619C18.7267 14.8125 16.6328 12.3834 17.0174 9.81237Z",
    fill: "#3901F1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecharge);
export default __webpack_public_path__ + "static/media/recharge.8958cd90aeb1e6621aa06657bc10ce03.svg";
export { ForwardRef as ReactComponent };